import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import colors from 'styles/colors';

const Svg = styled.svg`
  padding-bottom: 3px;
  padding-left: 3px;
  cursor: pointer;
`;

function CloseIcon({ color, size = 18, className }) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1 1L17 17M1 17L17 1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Svg>
  );
}

CloseIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
};

CloseIcon.defaultProps = {
  color: colors.functional.black,
};

export default CloseIcon;
